import React from 'react';
type FooterProps = {
  onOpenTerms: () => void;
  onOpenPrivacy: () => void;
};
export function Footer({
  onOpenTerms,
  onOpenPrivacy
}: FooterProps) {
  const links = [{
    label: 'Términos y condiciones',
    onClick: onOpenTerms
  }, {
    label: 'Política de privacidad',
    onClick: onOpenPrivacy
  }];
  return <footer className="w-full bg-ivory pb-28 pt-16 md:pb-16" data-id="element-96" data-mp="36qhdoq3hbpz3">
      <div className="mx-auto max-w-6xl px-6 lg:px-8" data-id="element-97" data-mp="3ufa4y995p9nd">
        <div className="flex flex-col items-center gap-8 border-t border-sand pt-12 md:flex-row md:items-start md:justify-between" data-id="element-98" data-mp="3ufjz8918i2yv">
          <div className="text-center md:text-left" data-id="element-99" data-mp="3lecbgkwcgkj1">
            <p className="font-display text-2xl font-light tracking-wide text-ink" data-id="element-100" data-mp="3ldkgncakmqtt">
              Punto de Acción
            </p>
            <p className="mt-2 font-sans text-[0.66rem] uppercase tracking-[0.16em] text-mute" data-id="element-101" data-mp="3qfjey7rgexjw">
              Kit Digital de Reinicio Emocional
            </p>
          </div>

          <nav aria-label="Enlaces legales" data-id="element-102" data-mp="2ezuubn1oaam9">
            <ul className="flex flex-col items-center gap-4 sm:flex-row sm:gap-8" data-id="element-103" data-mp="3l9adfilcf44f">
              {links.map(link => <li key={link.label} data-id="element-104" data-mp="3gapcti26iifg">
                  <button type="button" onClick={link.onClick} className="font-sans text-[0.78rem] font-light text-warmgray underline-offset-4 transition-colors duration-300 hover:text-gold hover:underline" data-id="element-105" data-mp="3gbqy0fcwslaw">
                    {link.label}
                  </button>
                </li>)}
            </ul>
          </nav>
        </div>

        <p className="mt-10 text-center font-sans text-[0.66rem] font-light leading-relaxed text-mute md:text-left" data-id="element-106" data-mp="80nskgzggmbt">
          © {new Date().getFullYear()} Punto de Acción. Todos los derechos reservados. Este material
          tiene fines de desarrollo personal y no sustituye acompañamiento profesional.
        </p>
      </div>
    </footer>;
}